var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { View, Animated } from 'react-native';
import Svg, { Circle } from 'react-native-svg';
import { useThemeContext } from '../../hooks';
const AnimatedCircle = Animated.createAnimatedComponent(Circle);
export const Progress = (_a) => {
    var { value, radius, outline, style } = _a, props = __rest(_a, ["value", "radius", "outline", "style"]);
    const { color } = useThemeContext();
    const innerRadius = radius - outline / 2;
    const circumference = Math.PI * innerRadius * 2;
    const progress = useRef(new Animated.Value(circumference)).current;
    useEffect(() => {
        Animated.timing(progress, {
            toValue: (circumference * (100 - value)) / 100,
            duration: 250,
            useNativeDriver: false
        }).start();
    }, [value]);
    return (React.createElement(View, Object.assign({ style: style }, props),
        React.createElement(Svg, { width: radius * 2, height: radius * 2, viewBox: `0 0 ${radius * 2} ${radius * 2}`, style: { transform: [{ rotate: '-90deg' }] } },
            React.createElement(Circle, { cx: radius, cy: radius, r: innerRadius, fill: 'none', stroke: color.primary.ghost, strokeWidth: outline }),
            React.createElement(AnimatedCircle, { cx: radius, cy: radius, r: innerRadius, fill: 'none', stroke: color.primary.solid, strokeWidth: outline, strokeDasharray: circumference, strokeDashoffset: progress, strokeLinecap: 'round' }))));
};
//# sourceMappingURL=index.js.map